(()=>{
  const collectionUrl=path=>{
    const url=new URL(path,location.origin);
    if(url.origin!==location.origin||!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\//i.test(url.pathname))throw Error('Invalid collection route');
    return url;
  };
  const bind=root=>{
    const content=root.closest('.atna-approved-content');if(!content||root.dataset.bound)return;root.dataset.bound='true';
    const choices=content.querySelectorAll('[data-atna-view]');
    const set=mode=>{if(!['list','grid'].includes(mode))return;root.dataset.view=mode;choices.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.atnaView===mode)));};
    choices.forEach(button=>button.addEventListener('click',()=>set(button.dataset.atnaView)));
    const form=content.querySelector('[data-atna-filter]');if(!form)return;
    const availability=form.querySelector('[name="filter.v.availability"]'),sort=form.querySelector('[name="sort_by"]');
    const stateUrl=path=>{
      const target=collectionUrl(path);
      target.searchParams.delete('filter.v.availability');
      if(availability?.checked)target.searchParams.set('filter.v.availability','1');
      if(sort?.value)target.searchParams.set('sort_by',sort.value);
      const preview=new URL(location.href).searchParams.get('preview_theme_id');
      if(/^\d+$/.test(preview||''))target.searchParams.set('preview_theme_id',preview);
      return target;
    };
    for(const link of content.querySelectorAll('[data-atna-collection-navigation] a[href],.pagination-wrapper a[href]')){
      try{link.href=stateUrl(link.getAttribute('href')).href;}catch{}
    }
    let brandDestination=null;
    form.addEventListener('submit',event=>{
      event.preventDefault();
      try{
        const target=stateUrl(brandDestination||form.getAttribute('action'));
        target.searchParams.delete('page');brandDestination=null;location.assign(target.href);
      }catch{}
    });
    form.querySelectorAll('select,input[type=checkbox]').forEach(input=>input.addEventListener('change',()=>{
      brandDestination=input.matches('[data-atna-brand-path]')?input.value:null;form.requestSubmit();
    }));
    form.classList.add('atna-approved-auto-filter');
  };
  document.querySelectorAll('[data-atna-catalog]').forEach(bind);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-atna-catalog]').forEach(bind));
})();

